export default __webpack_public_path__ + "static/media/ic_checked.b4f2217c.svg";